import { Injectable } from '@angular/core';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { environment } from "../../environments/environment";
import { NotifierService } from 'app/services/notifierService/notifier.service';

let LDKey="";
if(environment.currentEnvironment === "productionUS"){
  LDKey = environment.LDKeyProdUS;
} else if(environment.currentEnvironment === "stageUS"){
  LDKey = environment.LDKeyStageUS;
} else if(environment.currentEnvironment === "productionEU"){
  LDKey = environment.LDKeyProdEU;
} else if(environment.currentEnvironment === "stageEU"){
  LDKey = environment.LDKeyStageEU;
} else {
  LDKey = environment.LDKeyWobbly;
}

@Injectable()
export class LaunchDarklyService extends NotifierService{
  private ldClient
  private user;
  private allFlags = [];/*[{name:'UserManagerConversionToSPA', value:false},
                      {name:'CMD_CC_UploadTransaction', value:false},
                      {name:'q4-2022', value:false}];*/

  public initialize(name="test-user-key"){
    this.user = {
      name: "SYSTEM",
      key: name
    };
    this.ldClient = LDClient.initialize(LDKey, this.user);

    this.ldClient.on('ready', () => {
      // Uncomment the below line to show all flag's value.
      //this.showAllFlags();
      this.getUserDetails();
      this.getFlagValue();
      for(let i=0;i<this.allFlags.length;i++){
        this.ldClient.on('change:'+this.allFlags[i].name, (value, previous) => this.onFlagChange(i, value));
      }
     })
  }

  private getFlagValue(){
    this.allFlags.forEach((flag, index) => {
      let flagvalue = this.ldClient.variation(flag.name,false);
      this.setFlags(flagvalue, index)
    })    
  }

  private setFlags(flagvalue, index){
    console.log("LaunchDarkly Flagname: ",this.allFlags[index].name+" Flag value ",flagvalue);
    const regex = new RegExp(/^\${ *(\S+) *}$/);
    let match = false;
    let featuretoggle = false;

    flagvalue = (typeof flagvalue === 'string')?flagvalue.toLowerCase():flagvalue;

    switch(flagvalue){
      case 'true':
          featuretoggle = true;
          console.log("LaunchDarkly returning ",flagvalue)
          break;
      case 'false':
          featuretoggle = false;
          console.log("LaunchDarkly returning ",flagvalue)
          break;
      default:
        if(typeof flagvalue === 'boolean'){
          featuretoggle = flagvalue;
          console.log("LaunchDarkly returning boolean value - ",flagvalue)
        }else{
          match = regex.test(flagvalue);
          if(match){
             const groupToggleName = flagvalue.slice(2,flagvalue.length-1)
             let featuretoggle = this.ldClient.variation(groupToggleName, false)
             console.log("LaunchDarkly returning release toggle value - ",featuretoggle)
          }
        }
     }
     this.allFlags[index].value = featuretoggle;
     this._notifier.next(this.allFlags[index])
  }
 
  private showAllFlags() {
    let flags = this.ldClient.allFlags();
    console.log("LaunchDarkly Flags initialized. ",flags);
  }

  public getUserDetails(){
    let val = this.ldClient.getUser();
    console.log("LaunchDarkly user: ",val)
    return val;
  }

  private onFlagChange(index, value){
    console.log("LaunchDarkly change ",this.allFlags[index].name, value)
    this.allFlags[index].value = value;
  }
 }